export enum AllowedShiftBookingType {
  None,
  ShortNotice,
  Advance,
  ShortNoticeAndAdvance,
}
